import React from 'react'
import './HowToSell.css'

const AboutSection3 = () => {
  return (
    <div className='abouthow-container'>
        <h2>How To Sell Used Books On BookFlow?</h2>

        {/* <p></p> */}

        <div className='abouthow-box'>

            <div className='round-container '> 
                <div className="round register">
                    <i className="fa-regular fa-user"></i>
                </div>
                <h4>Simply Register</h4>
                <p>Register on BookWorm.in using the website and create an Account !</p>
            </div>

            <div className='round-container'> 
                <div className="round ad">
                    <i className="fa-solid fa-book-open"></i>
                </div>
                <h4>Post an Ad !</h4>
                <p>Post a Free AD on the website with good photos to attract buyers.</p>
            </div>

            <div className='round-container'> 
                <div className="round dashboard">
                    <i className="fa-regular fa-bell"></i>
                </div>
                <h4>Visit Dashboard</h4>
                <p>Keep a check on your dashboard for any Notifications !</p>
            </div>

        </div>
    </div>
  )
}

export default AboutSection3